import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-100 py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3">
              <div className="w-7 h-7 bg-gray-900 rounded-lg flex items-center justify-center">
                <i className="ri-file-text-line text-white text-xs"></i>
              </div>
              <span className="font-bold text-gray-900">WorkflowTools</span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed">Professional document templates with a simple credit-based system.</p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Product</h4>
            <ul className="space-y-2.5">
              <li><Link to="/templates" className="text-gray-500 text-sm hover:text-gray-900 cursor-pointer">Templates</Link></li>
              <li><Link to="/pricing" className="text-gray-500 text-sm hover:text-gray-900 cursor-pointer">Pricing</Link></li>
              <li><Link to="/dashboard" className="text-gray-500 text-sm hover:text-gray-900 cursor-pointer">Dashboard</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Company</h4>
            <ul className="space-y-2.5">
              <li><Link to="/contact" className="text-gray-500 text-sm hover:text-gray-900 cursor-pointer">Contact</Link></li>
              <li><a href="mailto:support@workflowtools.com" className="text-gray-500 text-sm hover:text-gray-900 cursor-pointer">Support</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Legal</h4>
            <ul className="space-y-2.5">
              <li><Link to="/privacy" className="text-gray-500 text-sm hover:text-gray-900 cursor-pointer">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-500 text-sm hover:text-gray-900 cursor-pointer">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-gray-400 text-xs">© {new Date().getFullYear()} WorkflowTools. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="text-gray-400 text-xs hover:text-gray-600 cursor-pointer">Terms</Link>
            <Link to="/privacy" className="text-gray-400 text-xs hover:text-gray-600 cursor-pointer">Privacy</Link>
            <Link to="/contact" className="text-gray-400 text-xs hover:text-gray-600 cursor-pointer">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
